// extracted by mini-css-extract-plugin
export default {"logoWrapper":"logo_logoWrapper__oNDZp","logo":"logo_logo__t7Cnk","logoText":"logo_logoText__a74vQ"};